// Source: app/scripts/directives/date-field.js
/*
 * Directive for date field
 *
 */

Auction.directive('dateField', ['crudService', '$filter', 'settings', '$timeout',
  function(crudService, $filter, settings, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'directives/dateField.html',
      scope: {
        fProperties: '@',
        fEntity: '=',
        // The label for translating entity name
        dateLabel: '@',
        // The name of the date field
        dateName: '@',
        // the model of the date
        dateModel: '=',
        // if it is required
        dateRequired: '=',
        dateMin: '=',
        dateMax: '=',
        showTime: '@',
        dateDisabled: '='
      },
      compile: function(tElem, attrs) {
        var picker = tElem[0].querySelector('quick-datepicker');
        if (picker) {
          if (attrs.dateName) {
            picker.setAttribute('name', attrs.dateName);
          }
          if (attrs.dateRequired == "true") {
            picker.setAttribute('required', true);
          }
          if (!attrs.showTime) {
            picker.setAttribute('disable-timepicker', true);
          }
        }
        return function(scope, elem, attrs) {
          scope.form = elem.parent().controller('form');
          scope.fName = attrs.dateName;
          scope.validationParams = attrs;
          scope.dateParseError = false;

          function bindPickerValidation() {
            var pickerEl = angular.element(elem[0].querySelector('.quickdate'));
            var pickerScope = pickerEl.isolateScope();
            if (!pickerScope) {
              return false;
            }

            function typedInvalid() {
              return !!(pickerScope.inputDateErr || pickerScope.inputTimeErr);
            }

            function syncDateValidity() {
              var invalid = typedInvalid();
              scope.dateParseError = invalid;
              if (invalid && pickerScope.inputDate) {
                pickerScope.mainButtonStr = pickerScope.inputDate;
              }
              var ctrl = pickerEl.controller('ngModel');
              if (ctrl) {
                ctrl.$setValidity('date', !invalid);
                if (invalid) {
                  ctrl.$setDirty();
                }
              }
            }

            scope.$watch(function() {
              return pickerScope.inputDateErr || pickerScope.inputTimeErr;
            }, function(invalid, wasInvalid) {
              syncDateValidity();
              if (invalid && !wasInvalid) {
                pickerScope.calendarShown = true;
              }
            });

            scope.$watch('dateModel', function(val) {
              if (!pickerScope) {
                return;
              }
              if (val instanceof Date && !isNaN(val.getTime())) {
                pickerScope.inputDateErr = false;
                pickerScope.inputTimeErr = false;
              } else if (!val && !pickerScope.inputDate) {
                pickerScope.inputDateErr = false;
                pickerScope.inputTimeErr = false;
              }
              syncDateValidity();
            });

            return true;
          }

          if (!bindPickerValidation()) {
            $timeout(bindPickerValidation, 0);
          }
        };
      },
      controller: function($scope, $element, crudService) {
        $scope.dateFormat = settings.dateFieldFormat;
        $scope.timeFormat = settings.dateFieldTimeFormat;
        $scope.$watch('fEntity', function(n, o) {
          if (n === o || !n) return;
          $scope.propertiesField = $scope.fProperties || $scope.dateName;
          $scope.fieldProperties = n.fieldProperties;

        });
        $scope.propertiesField = $scope.fProperties || $scope.dateName;
        $scope.fieldProperties = $scope.fEntity.fieldProperties;
      }
    };
  }
]);
